import $ from 'jquery';

export function getNewPageTile() {
    const suffix = ' - Consumer Reports';
    const hashTitle = getHashTitle();
    const pageTitle = $('.short-model-info .crux-page-title').text().trim();

    return `${pageTitle}${hashTitle}${suffix}`;
}

export function getHashTitle() {
    switch(window.location.hash) {
        case '#ratings':
            return ' Ratings';
        case '#brand-reliability':
            return ' Reliability';
        case '#specs':
            return ' Specs';
        case '#user-reviews':
            return ' Reviews';
        case '#write-reviews':
            return ' Write Reviews';
        case '#Price':
            return ' Prices';
        default:
            return '';
    }
}



// WEBPACK FOOTER //
// ./resources/modules/products/v2_0/components/ModelNav/pageTile.js